import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function RelatedDestinations() {
  const destinations = [{
    id: 'austria',
    name: 'Austria',
    image: 'https://images.unsplash.com/photo-1516550893885-498b67da269d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
    description: 'Alpine landscapes, historic cities, and classical music heritage',
    tourCount: 89
  }, {
    id: 'france',
    name: 'France',
    image: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
    description: 'Iconic landmarks, culinary excellence, and diverse landscapes',
    tourCount: 156
  }, {
    id: 'italy',
    name: 'Italy',
    image: 'https://images.unsplash.com/photo-1516483638261-f4dbaf036963?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
    description: 'Historic treasures, Mediterranean coastlines, and world-class cuisine',
    tourCount: 143
  }, {
    id: 'germany',
    name: 'Germany',
    image: 'https://images.unsplash.com/photo-1467269204594-9661b134dd2b?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=800&q=80',
    description: 'Fairytale castles, vibrant cities, and enchanting forests',
    tourCount: 112
  }];
  return <section className="py-16 bg-gray-50" data-id="element-1329">
      <div className="container mx-auto px-4" data-id="element-1330">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10" data-id="element-1331">
          <div data-id="element-1332">
            <h2 className="text-3xl font-bold text-gray-900 mb-3" data-id="element-1333">
              Explore Nearby Countries
            </h2>
            <p className="text-gray-600 max-w-2xl" data-id="element-1334">
              Discover other beautiful destinations in Europe that pair
              perfectly with your Switzerland adventure
            </p>
          </div>
          <a href="#" className="text-blue-600 hover:text-blue-800 font-medium flex items-center mt-4 md:mt-0" data-id="element-1335">
            <span data-id="element-1336">View all destinations</span>
            <ArrowRightIcon size={16} className="ml-1" data-id="element-1337" />
          </a>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-1338">
          {destinations.map(destination => <a key={destination.id} href="#" className="group bg-white rounded-lg shadow-sm overflow-hidden hover:shadow-md transition-shadow" data-id="element-1339">
              <div className="aspect-[4/3] relative overflow-hidden" data-id="element-1340">
                <img src={destination.image} alt={destination.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" data-id="element-1341" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" data-id="element-1342"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4" data-id="element-1343">
                  <h3 className="text-xl font-bold text-white" data-id="element-1344">
                    {destination.name}
                  </h3>
                </div>
              </div>
              <div className="p-4" data-id="element-1345">
                <p className="text-gray-700 mb-2 line-clamp-2" data-id="element-1346">
                  {destination.description}
                </p>
                <div className="flex items-center justify-between" data-id="element-1347">
                  <span className="text-sm text-blue-600 font-medium" data-id="element-1348">
                    {destination.tourCount} tours available
                  </span>
                  <span className="text-gray-600 group-hover:text-blue-600 transition-colors" data-id="element-1349">
                    <ArrowRightIcon size={16} data-id="element-1350" />
                  </span>
                </div>
              </div>
            </a>)}
        </div>
        <div className="mt-12 bg-blue-600 rounded-lg overflow-hidden" data-id="element-1351">
          <div className="flex flex-col lg:flex-row" data-id="element-1352">
            <div className="lg:w-1/2 p-8 lg:p-12 flex flex-col justify-center" data-id="element-1353">
              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-1354">
                Create Your Perfect European Adventure
              </h3>
              <p className="text-blue-100 mb-6" data-id="element-1355">
                Combine Switzerland with neighboring countries for an
                unforgettable multi-destination journey. Our travel experts can
                help you craft the perfect itinerary.
              </p>
              <div className="flex flex-col sm:flex-row gap-4" data-id="element-1356">
                <button className="px-6 py-3 bg-white text-blue-600 font-medium rounded-md hover:bg-blue-50 transition-colors" data-id="element-1357">
                  Build Custom Tour
                </button>
                <button className="px-6 py-3 bg-blue-700 text-white font-medium rounded-md hover:bg-blue-800 transition-colors" data-id="element-1358">
                  Speak to an Expert
                </button>
              </div>
            </div>
            <div className="lg:w-1/2 relative min-h-[300px]" data-id="element-1359">
              <img src="https://images.unsplash.com/photo-1476990789491-712b869b91a5?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=870&q=80" alt="Europe travel map" className="absolute inset-0 w-full h-full object-cover" data-id="element-1360" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}